import Vue from 'vue'
import * as ArcGIS from '@/helpers/ArcGIS'
import socket from '@/plugins/socket'

const state = {
  isSharingMap: false,

  host: false,

  usersShareMap: [],

  requestShareMap: null,

  mapExtent: null,

  // DIBUJOS
  graphics: [],

  // LAYERS
  visibility: null,

  opacity: null,

  // SIMULATION
  simulation: null,

  simulationTime: null,

  vientosSimulacion: null,

  // PLAN OPERACIONES
  planOperaciones: [],

  // ALINEACIONES CAMPBELL
  alineacionesCampbell: [],

  // ACTIVAR 2D
  is2D: true,

  // PERIMETRO SHARE
  perimetroShare: null,

  //LEFT MENU SHARE
  leftMenuShare: null,


}

const getters = {
  isSharingMap: (state) => state.isSharingMap,

  host: (state) => state.host,

  usersShareMap: (state) => state.usersShareMap,

  usersConEstado: (state, _getters, rootState) => {
    const usersLogged = rootState.usuario.usersLogged || [];

    const currentUsuario = rootState.usuario.currentUsuario;

    return usersLogged
      .filter(user => user.ID_SOCKET !== currentUsuario.ID_SOCKET)
  },

  requestShareMap: (state) => state.requestShareMap,

  mapExtent: (state) => state.mapExtent,

  // DIBUJOS
  graphics: (state) => state.graphics,

  // LAYERS
  visibility: (state) => state.visibility,

  opacity: (state) => state.opacity,

  // SIMULATION
  simulation: (state) => state.simulation,

  simulationTime: (state) => state.simulationTime,

  vientosSimulacion: (state) => state.vientosSimulacion,

  // PLAN OPERACIONES
  planOperaciones: (state) => state.planOperaciones,

  // ALINEACIONES CAMPBELL
  alineacionesCampbell: (state) => state.alineacionesCampbell,

  // ACTIVAR 2D
  is2D: (state) => state.is2D,

  // PERIMETRO SHARE
  perimetroShare: (state) => state.perimetroShare,


  //LEFT MENU SHARE
  leftMenuShare: (state) => state.leftMenuShare,


}

const mutations = {
  SET_IS_SHARING_MAP(state, isSharingMap) {
    state.isSharingMap = isSharingMap
  },

  SET_USERS_SHARE_MAP(state, usersShareMap) {
    state.usersShareMap = usersShareMap;
    state.host = usersShareMap.some(
      user => user.ESTADO === 'Aceptada'
    );
  },

  SET_REQUEST_SHARE_MAP(state, requestShareMap) {
    state.requestShareMap = requestShareMap
  },


  SOCKET_updatePerimetroShare(state, data) {
    if (!state.isSharingMap) return;
    state.perimetroShare = data;
  },

  SOCKET_updateLeftMenuShare(state, data) {
    if (!state.isSharingMap) return;
    state.leftMenuShare = data;
  },

  SOCKET_updateRouteShare(state, data) {
  if (!state.isSharingMap || !data?.geoJSON) return;
    ArcGIS.showRutasGeoJSON(data.geoJSON);
  },

  SOCKET_clearRouteShare(state) {
    if (!state.isSharingMap) return;

    ArcGIS.clearRutas();
  },

  SOCKET_updateCurrentLayerShare(state, data) {
    if (!state.isSharingMap) return;
    ArcGIS.setBaseMap(data);
  },




  CANCEL_REQUEST_SHARE_MAP(state) {
    state.requestShareMap = null;
    state.isSharingMap = false;
    state.graphics = [];
    state.planOperaciones = [];
    state.host = false;
  },

  ACCEPT_REQUEST_SHARE_MAP(state) {
    const requestShareMap = state.requestShareMap
    requestShareMap.response = true

    state.isSharingMap = true
  },

  // Recibir peticion de compartir mapa
  SOCKET_requestExtenTMap(state, data) { // La T no es una errata, es asi...
    state.requestShareMap = data
  },

  // Recibir nuevo extent del mapa
  SOCKET_changeExtentMap(state, data) {
    if (state.isSharingMap) {
      state.mapExtent = data
    }
  },

  // Alguien acepta el compartir pantalla
  SOCKET_acceptRequestExtentMap(state, socketId) {
    const index = state.usersShareMap.findIndex(
      user => user.ID_SOCKET === socketId
    );

    if (index === -1) return;

    Vue.set(state.usersShareMap[index], 'ESTADO', 'Aceptada');

    state.host = state.usersShareMap.some(
      user => user.ESTADO === 'Aceptada'
    );
  },

  // Alguien se ha salido del compartir mapa
  SOCKET_exitRequestExtentMap(state, socketId) {
    const index = state.usersShareMap.findIndex(
      user => user.ID_SOCKET === socketId
    );

    if (index === -1) return;

    Vue.set(state.usersShareMap[index], 'ESTADO', 'Exit');

    state.host = state.usersShareMap.some(
      user => user.ESTADO === 'Aceptada'
    );
  },

  // Cerrar compartir mapa
  async SOCKET_closeRequestExtentMap(state, _data) {
    state.requestShareMap = null
    state.isSharingMap = false
    await ArcGIS.clearSimulacion()
    ArcGIS.stopAlineacionesCampbellSketchViewModel()
    state.host = false
    state.planOperaciones = []
    this.notify('Compartir pantalla', 'Se ha terminado la sesión')
  },

  RESET_SHARE_MAP(state) {
    state.requestShareMap = null;
    state.isSharingMap = false;
    state.graphics = [];
    state.host = false;
    state.planOperaciones = [];
  },

  // DIBUJOS
  SOCKET_addGraphicsDraw(state, data) {
    state.graphics.push(data)
  },
  SOCKET_updateGraphicsDraw(state, data) {
    const index = state.graphics.findIndex(x => x.attributes.ID === data[0].attributes.ID)
    if (index !== -1) {
      const graphic = state.graphics[index]

      if (data[0].geometry.type === 'polyline') {
        graphic.coordenadas = data[0].geometry.paths
      } else if (data[0].geometry.type === 'polygon') {
        graphic.coordenadas = data[0].geometry.rings[0]
      } else if (data[0].geometry.type === 'point') {
        graphic.coordenadas = [data[0].geometry.x, data[0].geometry.y]
      }

      Vue.set(state.graphics, index, graphic)
    }
  },
  SOCKET_deleteGraphicsDraw(state, data) {
    const index = state.graphics.findIndex(x => x.attributes.ID === data[0].attributes.ID)
    if (index !== -1) {
      state.graphics.splice(index, 1)
    }
  },

  SOCKET_removeGraphicsDraw(state) {
    state.graphics = []
  },

  // LAYERS
  SOCKET_updateLayerVisibilityShare(state, data) {
    if (state.isSharingMap) {
      state.visibility = data
    }
  },

  SOCKET_updateLayerOpacityShare(state, data) {
    if (state.isSharingMap) {
      state.opacity = data
    }
  },

  // SIMULACION
  SOCKET_paintSimulationShare(state, data) {
    if (state.isSharingMap) {
      state.simulation = data
    }
  },

  SOCKET_updateSimulationTimeShare(state, data) {
    if (state.isSharingMap) {
      state.simulationTime = data
    }
  },



  SOCKET_paintVientoShare(state, data) {
    if (state.isSharingMap) {
      state.vientosSimulacion = data
    }
  },

  SOCKET_paintPlanOperacionesShare(state, data) {
    if (state.isSharingMap) {
      state.planOperaciones = data
    }
  },

  // ALINEACIONES CAMPBELL
  SOCKET_paintAlineacionesCampbellShare(state, data) {
    if (state.isSharingMap) {
      state.alineacionesCampbell = data
    }
  },

  SOCKET_stopAlineacionesCampbellShare(state) {
    if (state.isSharingMap) {
      ArcGIS.stopAlineacionesCampbellSketchViewModel()
    }
  },

  // ACTIVAR 2D
  SOCKET_activar2DShare(state, data) {
    if (state.isSharingMap) {
      state.is2D = data
    }
  },

  SOCKET_stopSharingScreen(state, _data) {
    state.requestShareMap = null;
    state.isSharingMap = false;
    state.graphics = [];
    state.planOperaciones = [];
    state.host = false;
  },
}

const actions = {
  setShareMap({ commit }, data) {
    if (!data) {
      if (state.requestShareMap) {
        socket.emit('exitRequestExtentMap', {
          ID_SOCKET: state.requestShareMap.clientRequest.ID_SOCKET,
          USUARIO: state.requestShareMap.clientRequest.USUARIO
        })
        commit('CANCEL_REQUEST_SHARE_MAP')
      } else {
        socket.emit('closeRequestExtentMap')
        commit('SET_USERS_SHARE_MAP', [])
      }
    }

    commit('SET_IS_SHARING_MAP', data)
  },

  updatePerimetroShare({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updatePerimetroShare', data)
    }
  },

  updateLeftMenuShare({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateLeftMenuShare', data)
    }
  },

  updateRouteShare({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateRouteShare', data)
    }
  },

  clearRouteShare({ state }) {
    if (state.isSharingMap && state.host) {
      socket.emit('clearRouteShare')
    }
  },



  setUsersShareMap({ commit, _state }, data) {
    commit('SET_USERS_SHARE_MAP', data)
    socket.emit('requestUsersExtentMap', data)
  },

  async cancelShareMapRequest({ commit }) {
    socket.emit('exitRequestExtentMap', {
      ID_SOCKET: state.requestShareMap.clientRequest.ID_SOCKET,
      USUARIO: state.requestShareMap.clientRequest.USUARIO
    })
    await ArcGIS.clearSimulacion();
    ArcGIS.stopAlineacionesCampbellSketchViewModel();

    commit('CANCEL_REQUEST_SHARE_MAP');
  },

  acceptShareMapRequest({ commit }) {
    socket.emit('acceptRequestExtentMap', {
      ID_SOCKET: state.requestShareMap.clientRequest.ID_SOCKET,
      USUARIO: state.requestShareMap.clientRequest.USUARIO
    })
    commit('ACCEPT_REQUEST_SHARE_MAP')
  },

  changeMapExtent({ _commit }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('changeExtentMap', data)
    }
  },

  // DIBUJOS
  addGraphics({ commit }, data) {
    commit('SOCKET_addGraphicsDraw', data)
    socket.emit('addGraphicsDraw', data)
  },
  deleteGraphics({ commit, state }, data) {
    commit('SOCKET_deleteGraphicsDraw', data)
    if (state.isSharingMap && state.host) {
      socket.emit('deleteGraphicsDraw', data)
    }
  },
  updateGraphics({ commit, state }, data) {
    commit('SOCKET_updateGraphicsDraw', data)
    if (state.isSharingMap && state.host) {
      socket.emit('updateGraphicsDraw', data)
    }
  },
  removeAllGraphics({ commit }) {
    commit('SOCKET_removeGraphicsDraw')
    socket.emit('removeGraphicsDraw')
  },

  // LAYERS
  updateLayerVisibility({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateLayerVisibilityShare', data)
    }
  },

  updateLayerOpacity({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateLayerOpacityShare', data)
    }
  },

  // SIMULACION
  paintSimulation({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('paintSimulationShare', data)
    }
  },

  updateSimulationTime({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateSimulationTimeShare', data)
    }
  },

  clearSimulation({ state }) {
    if (state.isSharingMap && state.host) {
      socket.emit('clearSimulationShare')
    }
  },

  paintViento({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('paintVientoShare', data)
    }
  },

  // PLAN OPERACIONES
  paintPlanOperaciones({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('paintPlanOperacionesShare', data)
    }
  },

  // ALINEACIONES CAMPBELL
  paintAlineacionesCampbell({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('paintAlineacionesCampbellShare', data)
    }
  },

  stopAlineacionesCampbell({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('stopAlineacionesCampbellShare', data)
    }
  },

  // ACTIVAR 2D
  activar2D({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('activar2DShare', data)
    }
  },

  updateCurrentLayerShare({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateCurrentLayerShare', data)
    }
  },
  updateCurrentWebMapShare({ state }, data) {
    if (state.isSharingMap && state.host) {
      socket.emit('updateCurrentWebMapShare', data)
    }
  },
  async SOCKET_updateCurrentWebMapShare({ state, dispatch }, webmap) {
    if (!state.isSharingMap) return;
    console.log("cambio")
    await dispatch(
      'webmap/loadSharedWebMap',
      webmap,
      { root: true }
    );
  },

  async socket_closeRequestExtentMap({ commit }) {
    await ArcGIS.clearSimulacion();
    ArcGIS.stopAlineacionesCampbellSketchViewModel();

    commit('RESET_SHARE_MAP');

    this.notify('Compartir pantalla', 'Se ha terminado la sesión');
  },

  async SOCKET_clearSimulationShare(state) {
    if (state.isSharingMap) {
      await ArcGIS.clearSimulacion()
    }
  },


}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
